module.exports = __webpack_public_path__ + "img/img-btnBg2.907371ba.png";